import { render, staticRenderFns } from "./NewInvestor.vue?vue&type=template&id=3ef9f2e0"
import script from "./NewInvestor.vue?vue&type=script&lang=js"
export * from "./NewInvestor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports